import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Card, Divider, Grid, IconButton, Typography, useTheme } from '@mui/material';
import { ButtonBasic } from '../../components';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { showModal } from 'react-redux-modal-provider';
import ModalAddEquipamientoServicio from './ModalAddEquipamientoServicio';
import EquipamientoTkService from '../../services/equipamiento-ticket.service';


const ModalEquipamientoServicio = ({
    show,
    hideModal,
    ticket,
    onGuardar,
    servicioId,
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const [itemSaveAll, setItemSaveAll] = useState([]);
    useEffect(() => {
        obtenerEquipamientos()
    }, [])
    const obtenerEquipamientos = async() =>{
        await EquipamientoTkService.getAll({ticketId: ticket}).then((tar)=>{
            setItemSaveAll(tar)
        })
    }
    const handleClose = () => hideModal();
    const openModalEquipamiento = () => {
        showModal(ModalAddEquipamientoServicio,{
            ticketId: ticket,
            servicioId,
            onGuardar,
            onGuardar2: obtenerEquipamientos
        })
    }
    const openModalEditEquipamiento = (itemSelect) => {
        showModal(ModalAddEquipamientoServicio,{
            ticketId: ticket,
            servicioId,
            onGuardar,
            item: itemSelect,
            onGuardar2: obtenerEquipamientos
        })
    }

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {`Equipamientos del servicio #${servicioId}`}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'end'}}>
                            <ButtonBasic
                                textButton='Nuevo Equipamiento'
                                onClick={()=>openModalEquipamiento()}
                                isLoading={isLoading}
                                variant='wk'
                                color='nextStep'
                                iconStart={<AddIcon />}
                            />
                        </Grid>
                        {itemSaveAll?.length > 0 && (
                            itemSaveAll.map((itEquip, index)=>(
                                <Grid item xs={12} md={6} lg={4} key={index}>
                                    <Card
                                        sx={{
                                            background: isDarkMode 
                                                ? 'linear-gradient(135deg, #2d3a52 0%, #1f2a40 100%)'
                                                : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                            borderRadius: 2,
                                            border: isDarkMode 
                                                ? '1px solid rgba(144, 202, 249, 0.2)'
                                                : '1px solid rgba(106, 120, 142, 0.2)',
                                            padding: 1.5,
                                            position: 'relative',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: isDarkMode
                                                    ? '0 8px 25px rgba(0, 0, 0, 0.4)'
                                                    : '0 8px 25px rgba(0, 0, 0, 0.1)',
                                                border: isDarkMode
                                                    ? '1px solid rgba(144, 202, 249, 0.4)'
                                                    : '1px solid rgba(3, 100, 255, 0.3)'
                                            }
                                        }}
                                    >
                                        {/* Header con nombre del equipo */}
                                        <Box sx={{
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'space-between',
                                            mb: 1.5
                                        }}>
                                            <Typography 
                                                sx={{
                                                    color: isDarkMode ? '#e0e0e0' : '#1a202c', 
                                                    fontWeight: 600, 
                                                    fontSize: 13,
                                                    lineHeight: 1.2,
                                                    maxWidth: 'calc(100% - 40px)',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }} 
                                                component='div'
                                            >
                                                {itEquip?.nombreEquipo_eqt || 'Sin nombre'}
                                            </Typography>
                                            <IconButton
                                                size="small"
                                                sx={{
                                                    backgroundColor: isDarkMode
                                                        ? 'rgba(144, 202, 249, 0.15)'
                                                        : 'rgba(3, 100, 255, 0.1)',
                                                    '&:hover': {
                                                        backgroundColor: isDarkMode
                                                            ? 'rgba(144, 202, 249, 0.25)'
                                                            : 'rgba(3, 100, 255, 0.2)',
                                                        transform: 'scale(1.1)'
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={()=>openModalEditEquipamiento(itEquip)}
                                            >
                                                <EditIcon sx={{color: isDarkMode ? '#90caf9' : '#0364FF', fontSize: 16}} />
                                            </IconButton>
                                        </Box>

                                        {/* Información compacta */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        fontWeight: 600, 
                                                        color: isDarkMode ? '#b0bec5' : '#4a5568',
                                                        minWidth: 35,
                                                        mr: 1
                                                    }}
                                                >
                                                    MAC:
                                                </Typography>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        color: isDarkMode ? '#e0e0e0' : '#2d3748',
                                                        fontFamily: 'monospace',
                                                        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                                                        padding: '2px 6px',
                                                        borderRadius: 1,
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    {itEquip?.macEquipo_eqt || '-'}
                                                </Typography>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        fontWeight: 600, 
                                                        color: isDarkMode ? '#b0bec5' : '#4a5568',
                                                        minWidth: 35,
                                                        mr: 1
                                                    }}
                                                >
                                                    SN:
                                                </Typography>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        color: isDarkMode ? '#e0e0e0' : '#2d3748',
                                                        fontFamily: 'monospace',
                                                        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                                                        padding: '2px 6px',
                                                        borderRadius: 1,
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    {itEquip?.snEquipo_eqt || '-'}
                                                </Typography>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        fontWeight: 600, 
                                                        color: isDarkMode ? '#b0bec5' : '#4a5568',
                                                        minWidth: 35,
                                                        mr: 1
                                                    }}
                                                >
                                                    Mov:
                                                </Typography>
                                                <Typography 
                                                    component="span" 
                                                    sx={{ 
                                                        fontSize: 11, 
                                                        backgroundColor: itEquip?.movimientoEquipo_eqt 
                                                            ? (isDarkMode ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)')
                                                            : (isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'),
                                                        color: itEquip?.movimientoEquipo_eqt 
                                                            ? (isDarkMode ? '#4ade80' : '#059669')
                                                            : (isDarkMode ? '#e0e0e0' : '#2d3748'),
                                                        padding: '2px 6px',
                                                        borderRadius: 1,
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    {itEquip?.movimientoEquipo_eqt || 'Sin movimiento'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))
                        )}
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cerrar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalEquipamientoServicio